/*!
 *  2019-1-16 22:17:31
 *  Copyright 2019 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _casting = __webpack_require__(5);
	
	var _casting2 = _interopRequireDefault(_casting);
	
	var _episode = __webpack_require__(7);
	
	var _episode2 = _interopRequireDefault(_episode);
	
	var _rating = __webpack_require__(8);
	
	var _clip = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $coll = (0, _jquery2['default'])('#tvpColl');
	var $tab = $coll.find('.tab_nav');
	var $tabList = $tab.find('.list_tab');
	
	var $programCont = $coll.find('#tv_program');
	var $episodeCont = $coll.find('#tv_episode');
	var $scheduleCont = $coll.find('#tv_schedule');
	var $ratingCont = $coll.find('#tv_rating');
	
	function schedule(ctx, nextCount, prevCount) {
	  var $btn = ctx.find('.tbl_head a');
	  var $tblHead = ctx.find('.tbl_head .tit_col');
	  var $tblBody = ctx.find('.tbl_body tr');
	
	  $btn.on('click', function () {
	    if ((0, _jquery2['default'])(this).hasClass('btn_next')) {
	      (0, _jquery2['default'])(this).addClass('btn_off');
	      (0, _jquery2['default'])(this).siblings('a').removeClass('btn_off');
	      $tblHead.each(function (index, item) {
	        nextSchedule(index, item);
	      });
	      $tblBody.each(function (index, item) {
	        var $tblBodyTd = (0, _jquery2['default'])(item).find('td');
	        $tblBodyTd.each(function (index, item) {
	          nextSchedule(index, item);
	        });
	      });
	    } else {
	      (0, _jquery2['default'])(this).addClass('btn_off');
	      (0, _jquery2['default'])(this).siblings('a').removeClass('btn_off');
	      $tblHead.each(function (index, item) {
	        prevSchedule(index, item);
	      });
	      $tblBody.each(function (index, item) {
	        var $tblBodyTd = (0, _jquery2['default'])(item).find('td');
	        $tblBodyTd.each(function (index, item) {
	          prevSchedule(index, item);
	        });
	      });
	    }
	  });
	  function nextSchedule(index, item) {
	    index < nextCount ? (0, _jquery2['default'])(item).addClass('hide') : (0, _jquery2['default'])(item).removeClass('hide');
	  }
	  function prevSchedule(index, item) {
	    index > prevCount ? (0, _jquery2['default'])(item).addClass('hide') : (0, _jquery2['default'])(item).removeClass('hide');
	  }
	}
	function descFold(ctx) {
	  var $ctx = ctx;
	  var $desc = $ctx.find('.episode_desc');
	  var $btn = $ctx.find('.more_comm');
	  var $txt = $btn.find('.inner');
	  $btn.on('click', function () {
	    $desc.toggleClass('open');
	    $desc.hasClass('open') ? $txt.text('접기') : $txt.text('더보기');
	  });
	}
	
	function characterPager() {
	  var $ctx = $coll.find('#listCharacter');
	  var $pagerNav = $ctx.find('.paging_nav');
	  var $contList = $ctx.find('.col_size5 li');
	  var pager = new SF.pager({
	    navigation: $pagerNav,
	    list: $contList,
	    viewCount: 5,
	    isInfinite: false
	  });
	}
	
	function btnMore(ctx) {
	  var $btn = ctx.find('.f_nb');
	  $btn.on('click', function () {
	    var contId = (0, _jquery2['default'])(this).data('id');
	    $tabList.children('li[data-tab="tv_' + contId + '"]').trigger('click');
	  });
	}
	
	var tabs = new SF.tab({
	  tab: (0, _jquery2['default'])('.tab_nav'),
	  cont: (0, _jquery2['default'])('#tabCont'),
	  callback: function callback() {
	
	    var $onTab = $tab.find('.on');
	    var tabId = $onTab.data('tab');
	
	    sessionStorage.setItem('state', tabId);
	
	    if (window.KTP) {
	      KTP.Player.pauseAll();
	    }
	
	    if ($onTab.data('tab') === 'tv_rating') {
	      C.TVP.data.tabInfo = 'rating';
	      (0, _rating.drawRatingChart)($ratingCont, 'ratingGraph');
	    }
	  }
	});
	
	function historySession() {
	  var windowState = SF.history.isHistoryBack;
	  var tabState = sessionStorage.state;
	
	  windowState ? $tabList.find('li[data-tab=' + tabState + ']').trigger('click') : '';
	}
	
	SF.loadModule('kakaotv', function (status, module) {
	  if (status === 'success') {
	    (0, _clip.videoClip)($coll);
	    (0, _clip.videoCol)($programCont);
	    (0, _clip.beforeClip)($programCont);
	  }
	  (0, _episode2['default'])($episodeCont);
	});
	
	(0, _rating.getRatingsData)().done(function (response) {
	  try {
	    (0, _rating.ratings)($programCont, response);
	    (0, _rating.ratings)($ratingCont, response);
	  } catch (e) {
	    console.log(e);
	  }
	});
	
	(0, _casting2['default'])($coll);
	(0, _rating.drawRatingChart)($ratingCont, 'ratingGraph');
	descFold($episodeCont);
	schedule($scheduleCont, 3, 3);
	schedule($episodeCont, 2, 3);
	characterPager();
	btnMore($programCont);
	historySession();

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.clipPlayer = exports.datePager = exports.callApi = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function callApi(data) {
	  var $callAjaxDeferred = new _jquery2['default'].Deferred();
	  _jquery2['default'].ajax({
	    url: data,
	    dataType: 'json'
	  }).success(function (response, statusText, data) {
	    if (statusText === 'success') {
	      $callAjaxDeferred.resolve(response);
	    } else {
	      console.error('Bad response data.');
	    }
	  }).fail(function (error) {
	    console.log('Failed to load Data', error);
	  });
	  return $callAjaxDeferred;
	}
	
	function datePager(ctx, cnt) {
	  var $ctx = ctx;
	  var $list = $ctx.find('.list_date li');
	  var len = $list.length;
	  var $on = $list.filter('.on');
	  var onIdx = $on.index();
	  var $wrapBtn = $ctx.find('.wrap_btn');
	  var $btnPrev = $wrapBtn.find('.btn_prev');
	  var $btnNext = $wrapBtn.find('.btn_next');
	  var viewCount = Math.ceil(len / cnt) - 1;
	  var currentIdx = parseInt(onIdx / cnt);
	
	  $btnPrev.on('click', function () {
	    if (currentIdx !== 0) {
	      currentIdx -= 1;
	      toggleClass();
	    } else {
	      return;
	    }
	    arrowClass();
	  });
	  $btnNext.on('click', function () {
	    if (viewCount > currentIdx) {
	      currentIdx += 1;
	      toggleClass();
	      (0, _jquery2['default'])(this).removeClass('btn_off');
	    } else {
	      return;
	    }
	    arrowClass();
	  });
	  function toggleClass() {
	    $list.each(function (index) {
	      var $this = (0, _jquery2['default'])(this);
	      currentIdx === parseInt(index / cnt) ? $this.removeClass('hide') : $this.addClass('hide');
	    });
	  }
	  function arrowClass() {
	    currentIdx === 0 ? $btnPrev.addClass('btn_off') : $btnPrev.removeClass('btn_off');
	    currentIdx === viewCount ? $btnNext.addClass('btn_off') : $btnNext.removeClass('btn_off');
	  }
	}
	
	function clipPlayer(container, videoId) {
	  var playerContainer = document.getElementById(container);
	  var clipLinkId = videoId;
	  var profile = 'HIGH';
	  var playerConfig = {
	    type: 'VOD',
	    service: 'daum_searchview',
	    id: clipLinkId + '@my',
	    profile: profile,
	    kakaotv: 0,
	    wmode: 'opaque',
	    autoplay: 1,
	    fs: 1
	  };
	  var player = KTP.Player.create(playerContainer, playerConfig);
	  player.load(clipLinkId, profile);
	}
	exports.callApi = callApi;
	exports.datePager = datePager;
	exports.clipPlayer = clipPlayer;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = "{{if #data}}<li class=\"info_appear\" style=\"float:left;\"><div class=\"wrap_role\"><div class=\"tit_appear\"> <strong class=\"txt_role\">{{:character.name}} 역</strong> {{if character.age && character.job }} <span class=\"txt_sub\">({{:character.age}}, {{:character.job}})</span> {{/if}} {{if character.age && !character.job }} <span class=\"txt_sub\">({{:character.age}})</span> {{/if}} {{if !character.age && character.job }} <span class=\"txt_sub\">({{:character.job}})</span> {{/if}} {{if dspArticle.id}} <a href=\"http://100.daum.net/encyclopedia/view/{{:dspArticle.id}}\" class=\"f_link\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=44&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">백과에서 보기</a> {{/if}} <a href=\"javascript:;\" class=\"ico_rwd ico_close_l\">닫기</a></div><p class=\"desc_appear\"> {{:character.description}}</p> {{if ~sourceUrl() != ''}}<div class=\"f_info\"> 출처 : <a href=\"{{:~sourceUrl()}}\" class=\"f_db_u\" target=\"_blank\" onclick=\"smartLog(this, 'dc=TVP&p=46&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">공식홈</a></div> {{/if}} {{if character.homoId != ''}}<div class=\"info_actor\"> {{if character.genreCode != '4'}}<div class=\"wrap_thumb\"> {{if character.searchYn == 'Y'}} <a href=\"?w=tot&ppkey={{:~encodeUri(character.homoId)}}&q={{:~encodeUri(character.castingName)}}&rtmaxcoll=PRF&DA=TVP\" class=\"thumb\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=43&r=3&rc=1&pg=1&at=link&d={{:~docId()}}', event);\"><img src=\"//search1.kakaocdn.net/thumb/C66x66.q85.fjpg/?fname={{:homo.mainImageUrl || character.mainImageUrl}}\" width=\"66\" height=\"66\" alt=\"\" data-size=\"66x66\" data-dstype=\"profile\" onerror=\"SF.errorImage(this)\"></a> {{else}} <span class=\"thumb\"><img src=\"//search1.kakaocdn.net/thumb/C66x66.q85.fjpg/?fname={{:homo.mainImageUrl || character.mainImageUrl}}\" width=\"66\" height=\"66\" alt=\"\" data-size=\"66x66\" data-dstype=\"profile\" onerror=\"SF.errorImage(this)\"></span> {{/if}}</div><div class=\"txt_info\"> <span class=\"txt_name\">{{if character.searchYn == 'Y'}} <a href=\"?w=tot&ppkey={{:~encodeUri(character.homoId)}}&q={{:~encodeUri(character.castingName)}}&rtmaxcoll=PRF&DA=TVP\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=43&r=3&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:character.castingName}}</a> {{else}} <span>{{:character.castingName}}</span> {{/if}} {{if homo.jobs != ''}} <span class=\"txt_sub\">({{:homo.jobs}})</span> {{/if}}</span> {{if homo.solarCalendar && ~replaceProf().year > '1900' && ~replaceProf().month != '00'}} <span class=\"txt_date\">{{:~replaceProf().birthday}}</span> {{/if}} {{for homo.castingPrograms ~len = homo.castingPrograms.length}} {{if #index<3 && ~len> 1 && ~len - 1 > #index}} <span class=\"txt_link\"><a href=\"?w=tot&q={{:~encodeUri(programName)}}&rtmaxcoll=TVP&irt=tv-program&irk={{:~encodeUri(programId)}}&DA=TVP\" class=\"link_work\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=43&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:programName}}</a>({{:year}})</span>, {{/if}} {{if ~len<2}} <span class=\"txt_link\"> <a href=\"?w=tot&q={{:~encodeUri(programName)}}&rtmaxcoll=TVP&irt=tv-program&irk={{:~encodeUri(programId)}}&DA=TVP\" class=\"link_work\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=43&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:programName}}</a>({{:year}})</span> {{/if}} {{if #index == 3 || #index == ~len - 1 && #index<4 && ~len> 1}} <span class=\"txt_link\"><a href=\"?w=tot&q={{:~encodeUri(programName)}}&rtmaxcoll=TVP&irt=tv-program&irk={{:~encodeUri(programId)}}&DA=TVP\" class=\"link_work\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=43&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:programName}}</a>({{:year}})</span> 등 {{/if}} {{/for}}</div> {{/if}}</div> {{/if}}</div> {{if sameCharacters.length > 0}}<div class=\"same_character\"> {{else}}<div class=\"same_character hide\"> {{/if}}<div class=\"tit_section\"> <strong class=\"txt_section\">동명 캐릭터</strong> {{if sameCharacters.length > 2}}<div class=\"paging_nav\"> <span class=\"num_page\"><span class=\"screen_out\">현재 페이지</span> <em class=\"emph_num\">1</em>&nbsp;/&nbsp; <span class=\"screen_out\">총 페이지</span> <span class=\"total_page\">{{:~sameListLength(sameCharacters.length / 2)}}</span></span> <span class=\"wrap_btn\"><a href=\"javascript:;\" class=\"btn_page btn_off\"><span class=\"ico_rwd ico_prev\">이전</span></a> <a href=\"javascript:;\" class=\"btn_page\"><span class=\"ico_rwd ico_next\">다음</span></a></span></div> {{/if}}</div> {{for sameCharacters}}<div class=\"info_actor {{if #index> 1}}hide{{/if}}\"><div class=\"wrap_thumb\"> <a href=\"?w=tot&q={{:~encodeUri(programName)}} {{:~encodeUri(name+'역')}}&rtmaxcoll=TVP&irt=tv-program&irk={{:programId}}&DA=TVP\" class=\"thumb\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=45&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\"><img src=\"//search1.kakaocdn.net/thumb/C66x66.q85.fjpg/?fname={{:mainImageUrl}}\" alt=\"\" width=\"66\" height=\"66\" data-size=\"66x66\" data-dstype=\"profile\" onerror=\"SF.errorImage(this)\"></a></div><div class=\"txt_info\"> <a href=\"?w=tot&q={{:~encodeUri(programName)}}&rtmaxcoll=TVP&irt=tv-program&irk={{:programId}}&DA=TVP\" class=\"txt_name\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=45&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:programName}}</a> <span class=\"txt_date\">{{:productionYear}}, {{:channel}}</span> <span class=\"txt_link\"><a href=\"?w=tot&ppkey={{:homoId}}&q={{:~encodeUri(castingName)}}&rtmaxcoll=PRF&DA=TVP\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=45&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:castingName}}</a></span></div></div> {{/for}}</div></li> {{/if}}";

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = "{{if playCount}}<li class=\"video_player\" style=\"float:left\"><div class=\"player_area\" id={{:parent}}></div><div class=\"wrap_cont\"> <a href={{:link}} class=\"tit_video\" target=\"_blank\" onclick=\"smartLog(this, 'dc=TVP&p=32&r=3&rc=1&pg=1&at=link&d={{:docId}}', event);\">{{:tit}}</a><div class=\"txt_info\"><span><span class=\"ico_tvp ico_play_s\"></span> {{:playCount}}</span> {{if regDate}} <span class=\"txt_upload\">업로드 : {{:regDate}}</span>{{/if}}</div></div></li> {{else}}<div class=\"player_area\" id=\"nowPlayer\"></div> {{/if}}";

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _casting = __webpack_require__(3);
	
	var _casting2 = _interopRequireDefault(_casting);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $castingTmpl = _jquery2['default'].templates(_casting2['default']);
	
	function castingDesc(ctx) {
	  var $ctx = ctx;
	  var $castingList = $ctx.find('.castingList ul');
	  openDesc($castingList, 5, $ctx);
	}
	function openDesc(castingList, std, $ctx) {
	
	  castingList.each(function () {
	    var $list = (0, _jquery2['default'])(this).children('li');
	    var $charName = $list.find('.f_link');
	    var len = $list.length;
	    var $this = $list.filter('.on');
	    $list.on('click', function () {
	      $this = (0, _jquery2['default'])(this);
	      var charId = $this.find('.wrap_thumb').data('id');
	      if (!charId) {
	        return;
	      }
	
	      $list.parent().find('.info_appear').remove();
	      var idx = $this.index() + 1;
	      var u = Math.ceil(idx / std);
	      // const dataUrl = '/qsearch?w=iron&m=tv_character&q=' + charId + '&key=' + charId + '&viewtype=json';
	      var params = {
	        cnucc: '',
	        w: 'iron',
	        m: 'tv_character',
	        q: charId,
	        key: charId,
	        viewtype: 'json'
	      };
	      var dataUrl = SF.getQsUrl(params, 1);
	      (0, _util.callApi)(dataUrl).done(function (response) {
	        try {
	          var castingData = response.RESULT.IRON_TV_CHARACTER;
	          var castingCharacter = castingData.character;
	          var desc = castingCharacter.description;
	
	          if (charId && castingData !== null && desc !== '') {
	            castingFunc(response);
	          } else {
	            return;
	          }
	
	          var $btnClose = $this.siblings().find('.ico_close_l');
	          $btnClose.on('click', function () {
	            $list.parent().find('.info_appear').remove();
	            $list.removeClass('on');
	          });
	        } catch (e) {
	          console.log(e);
	        }
	
	        function castingFunc(response) {
	          var castingData = response.RESULT.IRON_TV_CHARACTER;
	          var castingCharacter = castingData.character;
	
	          $list.removeClass('on');
	          $this.addClass('on');
	
	          var htmlOutput = $castingTmpl.render(castingData, {
	            sameListLength: function sameListLength(length) {
	              return Math.ceil(length);
	            },
	            replaceProf: function replaceProf() {
	              var birthday = castingData.homo.solarCalendar;
	              var year = birthday.substr(0, 4);
	              var month = birthday.substr(4, 2);
	              var day = birthday.substr(6, 2);
	              return { year: year, month: month, birthday: year + '.' + month + '.' + day };
	            },
	            encodeUri: function encodeUri(txt) {
	              return encodeURIComponent(txt);
	            },
	            sourceUrl: function sourceUrl() {
	              var homepageUrl = castingCharacter.homepage.length > 0 ? castingCharacter.homepage[0].url : undefined;
	              return castingCharacter.sourcePcUrl || homepageUrl || castingCharacter.channel.homepageUrl || '';
	            },
	            docId: function docId() {
	              return C.TVP.data.docId;
	            }
	          });
	
	          u * std >= len ? $list.last().after(htmlOutput) : $list.eq(u * std).before(htmlOutput);
	          paging();
	        }
	
	        function paging() {
	          var nav = $ctx.find('.info_appear .paging_nav');
	          var sameList = $ctx.find('.same_character .info_actor');
	          new SF.pager({
	            navigation: nav,
	            list: sameList,
	            viewCount: 2,
	            isInfinite: false
	          });
	        }
	      });
	    });
	    $charName.on('click', function (e) {
	      e.stopPropagation();
	    });
	    $this ? $this.click() : $this;
	  });
	}
	
	exports['default'] = castingDesc;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.beforeClip = exports.videoCol = exports.videoClip = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clip = __webpack_require__(4);
	
	var _clip2 = _interopRequireDefault(_clip);
	
	var _casting = __webpack_require__(3);
	
	var _casting2 = _interopRequireDefault(_casting);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $castingTmpl = _jquery2['default'].templates(_casting2['default']);
	
	
	var $clipTmpl = _jquery2['default'].templates(_clip2['default']);
	var docId = C.TVP.data.docId;
	
	function videoClip($ctx) {
	  var $wrapClip = $ctx.find('.clipList');
	  var $listClip = $wrapClip.find('.list_video');
	  openClip($listClip, 3);
	}
	
	function openClip(clipList, std) {
	  clipList.each(function () {
	    var $list = (0, _jquery2['default'])(this).children('li');
	    var len = $list.length;
	    $list.on('click', '.wrap_thumb', function () {
	      $list.parent().find('.video_player').remove();
	      var $this = (0, _jquery2['default'])(this);
	      var idx = $this.parent().index() + 1;
	
	      var $clipTit = $this.siblings('.f_link');
	      var $clipDate = $this.siblings('.f_date');
	      var clipId = $this.data('id');
	      var playCount = $this.data('count');
	      var regDate = $clipDate.text();
	      var clipLink = $clipTit.attr('href');
	      var clipTitText = $clipTit.text();
	      var u = Math.ceil(idx / std);
	      var parent = $this.parents('.tab_cont').attr('id');
	      var clipData = {
	        regDate: regDate,
	        playCount: comma(playCount),
	        tit: clipTitText,
	        link: decodeURIComponent(clipLink),
	        type: 'list',
	        parent: parent + 'Player',
	        docId: docId
	      };
	      var htmlOutput = $clipTmpl.render(clipData);
	
	      $list.filter('.on').removeClass('on');
	      $this.parent().addClass('on');
	
	      u * std >= 0 && u * std < len ? $list.eq(u * std).before(htmlOutput) : $list.parent().append(htmlOutput);
	
	      (0, _util.clipPlayer)(clipData.parent, clipId);
	
	      $list.find('.btn_close').on('click', function () {
	        (0, _jquery2['default'])(this).parent().removeClass('on');
	        $list.parent().find('.video_player').remove();
	      });
	    });
	  });
	}
	
	function comma(num) {
	  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function videoCol($ctx) {
	  var $colList = $ctx.find('.col_size3');
	  var $videoCol = $colList.find('.video_col');
	  var $player = $colList.children('li');
	
	  $videoCol.on('click', 'div[class="wrap_thumb"]', function () {
	    var $this = (0, _jquery2['default'])(this);
	    var $clipInfo = $this.siblings('.wrap_cont');
	    var $clipTit = $clipInfo.find('.txt_subject');
	    var clipId = $this.data('id');
	    var playCount = $this.data('count');
	    var titTxt = $clipTit.text();
	    var clipLink = $this.data('link');
	    var regDate = $clipInfo.find('.txt_date').text();
	    var parent = $this.parents('.tab_cont').attr('id');
	    var clipData = {
	      regDate: regDate,
	      playCount: comma(playCount),
	      tit: titTxt,
	      link: decodeURIComponent(clipLink),
	      type: 'videoColl',
	      parent: parent + 'player',
	      docId: docId
	    };
	    var htmlOutput = $clipTmpl.render(clipData);
	
	    if ($this.parent().hasClass('on')) {
	      $this.parent().removeClass('on');
	      $colList.find('.video_player').remove();
	    } else {
	      $videoCol.removeClass('on');
	      $this.parent().addClass('on');
	      $colList.find('.video_player').remove();
	      $player.last().after(htmlOutput);
	      (0, _util.clipPlayer)(clipData.parent, clipId);
	    }
	  });
	}
	
	function beforeClip($ctx) {
	  var $colList = $ctx.find('.clear');
	  var $list = $colList.find('li');
	  var $charName = $list.find('.f_link , .link_item');
	  $list.on('click', function () {
	    var $this = (0, _jquery2['default'])(this);
	    if ($this.parent().hasClass('video_col')) {
	      var $clipTit = $this.find('.link_item');
	      var $wrapThumb = $this.find('.wrap_thumb');
	      var clipId = $wrapThumb.data('id');
	      var playCount = $wrapThumb.data('count');
	      var regDate = $wrapThumb.data('date').toString();
	      var titTxt = $clipTit.text();
	      var clipLink = $clipTit.attr('href');
	      var parent = $this.parents('.tab_cont').attr('id');
	      var clipData = {
	        regDate: _jquery2['default'].format.dateformat(regDate, 'yyyy.MM.dd'),
	        playCount: comma(playCount),
	        tit: titTxt,
	        link: decodeURIComponent(clipLink),
	        type: 'before',
	        parent: parent + 'player',
	        docId: docId
	      };
	      var htmlOutput = $clipTmpl.render(clipData);
	      if ($this.hasClass('on')) {
	        $list.removeClass('on');
	        $colList.find('.video_player').remove();
	        $colList.removeClass('video_open');
	      } else {
	        $list.removeClass('on');
	        $colList.find('.info_appear').remove();
	        $this.addClass('on');
	        $this.after(htmlOutput);
	        (0, _util.clipPlayer)(clipData.parent, clipId);
	        $colList.removeClass('casting_open');
	        $colList.addClass('video_open');
	      }
	    } else {
	      var charId = $this.find('.wrap_thumb').data('id');
	      if (charId) {
	        var params = {
	          cnucc: '',
	          w: 'iron',
	          m: 'tv_character',
	          q: charId,
	          key: charId,
	          viewtype: 'json'
	        };
	        var dataUrl = SF.getQsUrl(params, 1);
	        (0, _util.callApi)(dataUrl).done(function (response) {
	          try {
	            var castingData = response.RESULT.IRON_TV_CHARACTER;
	            castingFunc($colList, $list, $this, castingData);
	          } catch (e) {
	            console.log(e);
	          }
	        });
	      } else {
	        return;
	      }
	      paging();
	      var $btnClose = $ctx.find('.ico_close_l');
	      $btnClose.on('click', function () {
	        $this.parent().find('.info_appear').remove();
	        $this.removeClass('on');
	        $colList.removeClass('casting_open');
	      });
	    }
	  });
	  $charName.on('click', function (e) {
	    e.stopPropagation();
	  });
	  function castingFunc(wrap, list, $this, data) {
	    wrap.removeClass('video_open');
	    wrap.addClass('casting_open');
	    wrap.find('.video_player').remove();
	    list.removeClass('on');
	    $this.addClass('on');
	
	    var htmlOutput = $castingTmpl.render(data, {
	      sameListLength: function sameListLength(length) {
	        return Math.ceil(length);
	      },
	      replaceProf: function replaceProf() {
	        var birthday = data.homo.solarCalendar;
	        var year = birthday.substr(0, 4);
	        var month = birthday.substr(4, 2);
	        var day = birthday.substr(6, 2);
	        return { year: year, month: month, birthday: year + '.' + month + '.' + day };
	      },
	      sourceUrl: function sourceUrl() {
	        var homepageUrl = data.character.homepage.length > 0 ? data.character.homepage[0].url : undefined;
	        return data.character.sourcePcUrl || homepageUrl || data.character.channel.homepageUrl || '';
	      },
	      encodeUri: function encodeUri(txt) {
	        return encodeURIComponent(txt);
	      },
	      docId: function docId() {
	        return C.TVP.data.docId;
	      }
	    });
	
	    $ctx.find('.info_appear').remove();
	    $this.parent().append(htmlOutput);
	  }
	  function paging() {
	    var nav = (0, _jquery2['default'])('.info_appear .paging_nav');
	    var sameList = (0, _jquery2['default'])('.same_character .info_actor');
	    new SF.pager({
	      navigation: nav,
	      list: sameList,
	      viewCount: 2,
	      isInfinite: false
	    });
	  }
	}
	
	exports.videoClip = videoClip;
	exports.videoCol = videoCol;
	exports.beforeClip = beforeClip;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clip = __webpack_require__(4);
	
	var _clip2 = _interopRequireDefault(_clip);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $clipTmpl = _jquery2['default'].templates(_clip2['default']);
	
	
	function episodeClip($wrapper) {
	  var $cont = $wrapper.find('.episode_cont');
	  var $btn = $cont.find('.wrap_player .thumb');
	  var clipData = {};
	
	  $btn.on('click', function () {
	    var $this = (0, _jquery2['default'])(this);
	    var $area = (0, _jquery2['default'])(this).parent();
	    var vid = $this.data('id');
	    var htmlOutput = $clipTmpl.render(clipData);
	    $area.empty();
	    $area.html(htmlOutput);
	    (0, _util.clipPlayer)('nowPlayer', vid);
	  });
	}
	
	function episodePager(ctx) {
	  var $ctx = ctx;
	
	  var $guestCont = $ctx.find('.guest_cont');
	  var $guestNav = $guestCont.find('.paging_nav');
	  var $guestList = $guestCont.find('.col_size5 li');
	
	  var $placeCont = $ctx.find('.place_cont');
	  var $placeNav = $placeCont.find('.paging_nav');
	  var $placeList = $placeCont.find('.list_place li');
	
	  var guestPager = new SF.pager({
	    navigation: $guestNav,
	    list: $guestList,
	    viewCount: 5,
	    isInfinite: false
	  });
	
	  var placePager = new SF.pager({
	    navigation: $placeNav,
	    list: $placeList,
	    viewCount: 2,
	    isInfinite: false
	  });
	}
	
	function episodeDetail(ctx) {
	  if (SF.urlParameter.w === 'tot') {
	    episodeClip(ctx);
	    episodePager(ctx);
	  } else {
	    episodeClip(ctx);
	    (0, _util.datePager)(ctx, 7);
	  }
	}
	
	exports['default'] = episodeDetail;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getRatingsData = exports.drawRatingChart = exports.ratings = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _util = __webpack_require__(2);
	
	var _rating = __webpack_require__(9);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $ratingTmpl = _jquery2['default'].templates(_rating2['default']);
	var dataArr = void 0,
	    chartData = C.TVP.data.ratings;
	
	// const dataUrl = '/qsearch?w=tv&m=ratings&viewtype=json&q=&mk=Wg5NJcuFoogAAGuFJRUAAAAf&uk=V3y5Yt7nKNoAAUk18EcAAACr';
	
	var onAirSchedule = C.TVP.data.onAirSchedule || {};
	var channelId = Number(onAirSchedule.channelId) || '';
	var realtimeData = {};
	
	function dateNow() {
	  var date = new Date();
	  Date.prototype.now = function () {
	    var month = this.getMonth() + 1;
	    var day = this.getDate();
	    var hour = this.getHours();
	    var minutes = this.getMinutes();
	    return [this.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day, (hour > 9 ? '' : '0') + hour, (minutes > 9 ? '' : '0') + minutes].join('');
	  };
	  return date.now();
	}
	
	function getRatingsData() {
	  var $ratingDeferred = new _jquery2['default'].Deferred();
	  var params = { cnucc: '', w: 'tv', m: 'ratings', viewtype: 'json' };
	  var dataUrl = SF.getQsUrl(params, 1);
	
	  (0, _util.callApi)(dataUrl).done(function (response) {
	    $ratingDeferred.resolve(response);
	  });
	  return $ratingDeferred;
	}
	
	function ratings(ctx, response) {
	  var rankData = response.RESULT.TV_REALTIME_RATINGS.data.items;
	  rankData.forEach(function (item) {
	    item.channelId === channelId ? realtimeData.thisRating = item.ratings : '';
	  });
	
	  if (onAirSchedule.broadcastStartTime <= dateNow() && dateNow() < onAirSchedule.broadcastEndTime && onAirSchedule.rebroadcastYn === 'N' && realtimeData.thisRating) {
	    var $ctx = ctx;
	    var $wrapper = $ctx.find('.realtimeRating');
	
	    $wrapper.removeClass('hide');
	    realtimeData.ratingRank = rankData.slice(0, 3);
	    realtimeRating(onAirSchedule, realtimeData, onAirSchedule);
	
	    var htmlOutput = $ratingTmpl.render(realtimeData, {
	      txtPercent: function txtPercent(txt, limit) {
	        return Number(txt).toFixed(limit);
	      },
	      rankWidth: function rankWidth(rating) {
	        return Math.ceil(rating / realtimeData.ratingRank[0].ratings * 100) + '%';
	      },
	      graphType: function graphType() {
	        return $wrapper.parents('.tab_cont').attr('id');
	      },
	      startTime: function startTime() {
	        return _jquery2['default'].format.dateformat(onAirSchedule.broadcastDate, 'MM.dd (e)');
	      },
	      txtPosition: function txtPosition(num) {
	        if (num >= 25 && num <= 85) {
	          return (num - 25).toFixed(2);
	        } else if (num > 85) {
	          return 60;
	        }
	      }, encodeUri: function encodeUri(txt) {
	        return encodeURIComponent(txt);
	      },
	      docId: function docId() {
	        return C.TVP.data.docId;
	      }
	    });
	    $wrapper.html(htmlOutput);
	  }
	}
	
	function replaceColon(str) {
	  return str.replace(/\B(?=(\d{2})+(?!\d))/g, ":");
	}
	function toTimeObject(time) {
	  var year = time.substr(0, 4);
	  var month = time.substr(4, 2) - 1;
	  var day = time.substr(6, 2);
	  var hour = time.substr(8, 2);
	  var min = time.substr(10, 2);
	
	  return new Date(year, month, day, hour, min);
	}
	
	function realtimeRating(data, data2, schedule) {
	  var startTime = toTimeObject(data.broadcastStartTime).getTime();
	  var endTime = toTimeObject(data.broadcastEndTime).getTime();
	  var nowTime = new Date().getTime();
	  var duration = (endTime - startTime) / 60000;
	  var passTime = (nowTime - startTime) / 60000;
	
	  data2.startTime = replaceColon(schedule.broadcastStartTime.slice(-4));
	  data2.endTime = replaceColon(schedule.broadcastEndTime.slice(-4));
	  data2.channelName = schedule.channelName;
	  data2.sequence = schedule.episodeSequence;
	  data2.width = passTime / duration * 100;
	}
	
	function drawRatingChart(cont, graph1) {
	  var $btnPrev = cont.find('.btn_prev');
	  var $btnNext = cont.find('.btn_next');
	  var chart = void 0,
	      len = dataArr.length - 1,
	      idx = 0;
	  if (!chartData) {
	    return;
	  }
	
	  SF.loadModule('AmCharts', function (status, info) {
	    if (status !== "success") return;
	    chart = new AmCharts.makeChart(graph1, {
	      type: 'serial',
	      dataProvider: chartData,
	      categoryField: 'label',
	      marginRight: 0,
	      marginLeft: 0,
	      categoryAxis: {
	        gridAlpha: 0,
	        axisThickness: 0,
	        axisAlpha: 0,
	        color: '#777'
	      },
	      valueAxes: [{
	        axisAlpha: 0,
	        gridAlpha: 0,
	        gridColor: '#f0f1f3',
	        axisThickness: 0,
	        gridThickness: 1,
	        ignoreAxisWidth: true,
	        axisColor: '#777777',
	        includeGuidesInMinMax: false
	      }],
	      graphs: [{
	        valueField: 'rating',
	        bullet: 'round',
	        bulletSize: 5,
	        bulletBorderAlpha: 1,
	        bulletBorderColor: "#f73e47",
	        bulletBorderThickness: 1,
	        bulletColor: '#ffffff',
	        lineColor: '#ff0000',
	        labelText: '[[rating]]%',
	        showBalloon: false
	      }]
	    });
	    $btnPrev.on('click', function () {
	      if (idx < len) {
	        idx += 1;
	        chart.dataProvider = dataArr[idx];
	        chart.validateData();
	        (0, _jquery2['default'])(this).addClass('on');
	        $btnNext.addClass('on');
	      } else {
	        (0, _jquery2['default'])(this).removeClass('on');
	      }
	    });
	
	    $btnNext.on('click', function () {
	      if (idx > 0 && idx <= len) {
	        idx -= 1;
	        chart.dataProvider = dataArr[idx];
	        chart.validateData();
	        (0, _jquery2['default'])(this).addClass('on');
	        $btnPrev.addClass('on');
	      } else {
	        (0, _jquery2['default'])(this).removeClass('on');
	      }
	    });
	  });
	}
	
	function graphDataInit(ctx) {
	  C.TVP.data.ratings.reverse();
	  chartData.forEach(function (item, index) {
	    var date = item.date;
	    var formattedDate = [date.substr(0, 4), date.substr(4, 2), date.substr(6, 2)].map(function (item, index) {
	      try {
	        return Number(item);
	      } catch (e) {
	        return item;
	      }
	    }).join('.');
	
	    chartData[index]['label'] = item.sequence + '<br>' + formattedDate;
	  });
	  dataArr = chunk(chartData, 5);
	  dataArr.forEach(function (item, index) {
	    item.reverse();
	  });
	  chartData = dataArr[0];
	}
	
	function chunk(arg, size) {
	  var arr = [];
	  var arrLength = arg.length;
	  var count = arrLength / size;
	  for (var i = 0; i < count; i++) {
	    arr.push(arg.splice(0, size));
	  }
	  return arr;
	}
	
	graphDataInit();
	
	exports.ratings = ratings;
	exports.drawRatingChart = drawRatingChart;
	exports.getRatingsData = getRatingsData;

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rating_cont {{if ~graphType() == 'tv_rating'}}rating_type2{{else}}rating_type1{{/if}}\"><div class=\"rating_realtime\"><div class=\"tit_section\"> {{if ~graphType() == 'tab_rating'}} <strong class=\"txt_section\">실시간 시청률</strong> {{else}} <strong class=\"txt_section\">{{:~startTime()}} {{:startTime}}</strong> <span class=\"f_l\"><a href=\"?w=tot&q={{:~encodeUri(channelName)}}{{:~encodeUri('편성표')}}&DA=TVP&rtmaxcoll=B3T\" class=\"f_link\" onclick=\"smartLog(this, 'dc=TVP&p=29&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:channelName}}</a> {{if sequence}} <span class=\"txt_sequence\">{{:sequence}}회</span> {{/if}} <span class=\"ico_onair\">ON AIR</span></span> {{/if}}<div class=\"mg_expander\" style=\"padding-right:20px\"><a href=\"http://www.atam.co.kr/\" class=\"f_nb\" target=\"_blank\" onclick=\"smartLog(this, 'dc=TVP&p=87&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">출처 : ATAM</a></div></div> <span class=\"f_l\">{{if ~graphType() == 'tab_rating'}} <span>{{:startTime}}</span> <a href=\"?w=tot&q={{:~encodeUri(channelName)}}{{:~encodeUri('편성표')}}&DA=TVP&rtmaxcoll=B3T\" class=\"f_link\" onclick=\"smartLog(this, 'dc=TVP&p=29&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:channelName}}</a> {{if sequence}} <span class=\"txt_episode\">{{:sequence}}회</span>{{/if}} <span class=\"ico_live\">생</span> {{/if}}</span><div class=\"graph_realtime\"><div class=\"graph_bar\"><span class=\"inner_bar\" style=\"width:{{:~txtPercent(width)}}%;\"></span> <span class=\" txt_rating\" style=\"display:block;padding-left:{{:~txtPosition(width)}}%\">실시간 시청률 <strong class=\"txt_percent\">{{:~txtPercent(thisRating,2)}}%</strong></span></div> <span class=\"txt_time\"><span class=\"f_l\"><span class=\"screen_out\">방송 시작 시간</span>{{:startTime}}</span> <span class=\"f_r\"><span class=\"screen_out\">방송 종료 시간</span>{{:endTime}}</span></span></div></div><div class=\"rating_rank\"><div class=\"tit_section\"> <strong class=\"txt_section\">채널 실시간 시청률</strong><div class=\"mg_expander\"> <a href=\"?w=tot&q={{:~encodeUri('실시간 시청률')}}&DA=TVP&rtmaxcoll=B3T\" class=\"f_nb\" target=\"_self\" onclick=\"smartLog(this, 'dc=TVP&p=29&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">더보기</a></div></div><ol class=\"graph_list\"> {{for ratingRank}}<li> <a href=\"?w=tot&q={{:~encodeUri(channelName)}}{{:~encodeUri('편성표')}}&DA=TVP&rtmaxcoll=B3T\" class=\"txt_channel\" onclick=\"smartLog(this, 'dc=TVP&p=29&r=1&rc=1&pg=1&at=link&d={{:~docId()}}', event);\">{{:channelName}}</a> <span class=\"graph_bar\"><span class=\"inner_bar\" {{if #index>0}}style=\"width:{{:~rankWidth(ratings)}}\"{{/if}}></span></span> <span class=\"txt_percent\">{{:~txtPercent(ratings,2)}}%</span></li> {{/for}}</ol></div></div>";

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** TVP/TVP.bundle.8aa4130.js
 **/